import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';

export default class ExtraLayer{
    constructor(mainmap) {
        this.mainmap=mainmap;
        // 添加配件图层
        this.addExtraLayerWMS();
    }
    // 增加配件图层
    addExtraLayerWMS(){
        // var wms = new TileLayer({
        //     source: new TileWMS({
        //         url: 'http://localhost:8080/geoserver/phems/wms',
        //         params: {'LAYERS': 'phems:trap', 'TILED': true},
        //         serverType: 'geoserver',
        //         // Countries have transparency, so do not fade tiles:
        //         transition: 0,
        //     }),
        //     zIndex:9999
        // });
        // this.mainmap.addLayer(wms);
        // 加载疏水器图层
        var wms = new TileLayer({
            source: new TileWMS({
                url: 'http://phemsgis.proheng.net/geoserver/hdxs/wms',
                params: {'LAYERS': 'hdxs:engineTrap', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                transition: 0,
            }),
            zIndex:30
        });
        this.mainmap.addLayer(wms);
        // 加载补偿器图层
        wms = new TileLayer({
            source: new TileWMS({
                url: 'http://phemsgis.proheng.net/geoserver/hdxs/wms',
                params: {'LAYERS': 'hdxs:engineCompensator', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                transition: 0,
            }),
            zIndex:30
        });
        this.mainmap.addLayer(wms);
        // 管线长度和管径
        wms = new TileLayer({
            source: new TileWMS({
                url: 'http://phemsgis.proheng.net/geoserver/hdxs/wms',
                params: {'LAYERS': 'hdxs:engineLength', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                transition: 0,
            }),
            zIndex:30
        });
        this.mainmap.addLayer(wms);

        // 管道的端点
        wms = new TileLayer({
            source: new TileWMS({
                url: 'http://phemsgis.proheng.net/geoserver/hdxs/wms',
                params: {'LAYERS': 'hdxs:engineTerminal', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                transition: 0,
            }),
            zIndex:30
        });
        this.mainmap.addLayer(wms);
    }
}
